import { Skeleton } from "antd";
import type { ReactNode } from "react";
import classNames from "~utils/classNames";
import "./FormSkeleton.scss";

type Props = {
  label?: ReactNode;
  className?: string;
};

export const FormSkeleton = ({ label, className }: Props) => (
  <div className={classNames("form-skeleton", className)}>
    {label ? (
      <label className="form-skeleton__label">{label}</label>
    ) : (
      <Skeleton.Input active size="small" className="form-skeleton__skeleton-label" />
    )}
    <Skeleton.Input active block className="form-skeleton__skeleton-input" />
  </div>
);
